import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch7_p02 } from "../../../layouts/ch7_p02/ch7_p02";

export class Chapter7Page2 extends AbstractStoryState implements ReturnType<typeof ch7_p02> {

    readonly bg = this.addChild(new SceneSprite());
    readonly horse = this.addChild(new SceneSprite());
    readonly holly = this.addChild(new SceneSprite());

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch7_p02/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch7_p02/"));
    readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch7_p02/"));
    readonly linesRight = this.addChild(SceneSprite.withPrefix("ch7_p02/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch7_p02.call(this);

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        TweenLite.delayedCall(1.5, () => {
            this.gotoNextState({ transition: "left" });
        });
    }
}